import React from "react";
import { View, Text, Button } from "ui";
import { styled } from "styles";

const questions = [
  {
    title: "De ce am nevoie sa-mi fac cont",
    content:
      "Pentru a putea fi alertat printr-un sms sau e-mail inainte cu cateva zile ca urmeaza data expirarii unei asigurari, document tehnic etc."
  },
  {
    title: "Ce este un memo",
    content:
      "Memo poate fi un numar de masina, un numar de sasiu sau orice altceva customizat de Dvs."
  },
  {
    title:
      "De ce am pe un memo cu numar de masina mai multe alerte dezactivate?",
    content:
      "Acelea sunt sugestiile noastre pentru Dvs, pot fi importante. Le puteti activa prin adaugarea datei de expirare."
  },
  {
    title: "Ce este o alerta?",
    content: "Alerta este elementul ce expira asociat unui memo."
  },
  {
    title: "Pot adauga memo ce nu au legatura cu masini?",
    content:
      "Evident. Puteti primi alerte si pentru programarile medicale sau orice doriti."
  },
  {
    title: "Pot adauga o alerta ce nu se afla in alertele predefinite?",
    content: "Da, din contul Dvs."
  },
  {
    title: "Cate memo pot adauga",
    content: "Puteti adauga oricate memo-uri avet nevoie."
  },
  {
    title: "Cate alerte pentru un memo pot adauga?",
    content: "Puteti adauga oricate alerte aveti nevoie."
  },
  {
    title: "La un memo pot adauga poze?",
    content: "Da, puteti adauga pana la 8 poze ce au legatura cu continutul."
  },
  {
    title: "Pe cate telefoane pot primi sms-ul de alerta?",
    content: "Maxim 6 numere de telefon."
  },
  {
    title: "Unde pot adauga mai multe numere de telefon?",
    content: "Din setari"
  },
  {
    title: "Unde pot adauga mai multe adrese de e-mail?",
    content: "Din setari"
  },
  {
    title: "Cate persoane se pot loga la contul AUTOMEMO?",
    content:
      "Oricate doriti dumneavoastra, atat timp cat mai multe persoane detin datele de logare la cont (directori, coordonatori, secretare, etc), ele se pot loga in cont de la orice calculator sau telefon mobil si pot adauga sau modifica date."
  },
  {
    title: "Datele mele personale sunt protejate?",
    content:
      "Folosim cele mai noi sisteme de criptare, datele Dvs. sunt protejate."
  },
  {
    title: "SMS-ul de alerta pe care il voi primi este gratuit?",
    content: "Da. Primirea sms-ului nu va obliga la niciun cost."
  },
  {
    title: "Aplicatia AutoMemo poate fi instalata pe orice telefon?",
    content:
      "Poate fi instalata atat pe iPhone cat si pe cele cu sistem de operare Android."
  }
];

export default class Faq extends React.Component {
  public render = () => {
    return (
      <View flexDirection="column" alignItems="flex-start">
        <Text alignSelf="center" fontWeight="bold" fontSize={5} mr={5} ml={5}>
          Intrebari Frecvente
        </Text>
        <View pl={2} pr={2} mt={3} flexDirection="column">
          {questions.map((q, i) => (
            <React.Fragment>
              <View
                bg="primary"
                p={2}
                mt={3}
                mb={1}
                alignItems="center"
                justifyContent="center"
                borderRadius={10}
              >
                <Text fontSize={3} color="white">
                  {i + 1}. {q.title}
                </Text>
              </View>
              <Text mt={1} fontSize={3}>
                {q.content}
              </Text>
            </React.Fragment>
          ))}
        </View>
      </View>
    );
  }
}

const Title = styled(View)`
  box-shadow: 0px 3px 3px grey;
  border-radius: 10px;
`;

const Subtitle = styled(Text)``;



// WEBPACK FOOTER //
// ./src/pages/Faq.tsx